import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DataTables from '../commonComponent/DataTable/DataTables';
import SweetAlert from 'sweetalert2';
import { URL_Start } from '../../../constant';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import Alert from "react-bootstrap/Alert";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PrintPDF from '../commonComponent/PrintPDF';
import EditToolTip from '../UI/ToolTips/EditToolTip';
import { CSVLink } from "react-csv";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { MultiSelect } from 'react-multi-select-component';
import '../../../pages/admin/react-multiselect.css';
import { Check } from 'react-feather';
import { array } from 'yup/lib/locale';
import Select from 'react-select';
import SampleToolTip from '../UI/ToolTips/SampleToolTip';
const DayEndDiffReport = () => {
    let fromDate = useRef();
    let toDate = useRef();
    let btnrpttype = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [crntPageNO, setCrntPageNO] = useState(0);
    const [defaultDate, setDefaultDate] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const openEditModal = () => { setIsEdit(!isEdit); }
    const [users, setUsers] = useState([]);
    const [typeSelected, setTypeSelected] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [popupTableData, setPopupTableData] = useState([]);
    const [testsModal, setTestsModal] = useState();
    const openModal = () => { setTestsModal(!testsModal); };

    const paginationOptions = {
        sizePerPage: 10, showTotal: false, firstPageText: 'First', prePageText: 'Back', nextPageText: 'Next', lastPageText: 'Last',
        onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); }
    };
    const idFormatter = (cellData, rowData, rowIndex, extraData) => {
            return <React.Fragment>
                <div>
                    <span>{crntPageNO + rowIndex + 1}</span>
                </div>
            </React.Fragment>
        }
     const actionFormatter = (cellData, rowData, rowIndex, extraData) => {
         return <React.Fragment>
             <div>
                 <SampleToolTip title="Click for amount Difference" placement="top" class="fa fa-eye" id={rowData.DayEndRequestId} onClick={() => GetDayEndDetails(rowData.DayEndRequestId)} />
             </div>
         </React.Fragment>
    }

    const GetDayEndDetails = async (DayEndRequestID) => {
        const ObjServiceCollection = {
            UserId: DayEndRequestID,

        };
        setIsLoading(true);
        let url = URL_Start + 'reports/getdayenddataDetails'
        await axios.post(url, ObjServiceCollection).then((response) => {
            const data = response.data;
            if (data.Success) {
                if (data.Data != null) {
                    // setPopupTableData(data.Data); 
                    // openModal();
                    setPopupTableData([]);
                    setTimeout(() => {
                    setPopupTableData(data.Data);
                    openModal();
                    }, 0);
                }
                setIsLoading(false);
            }
            else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); setIsLoading(false); }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } setIsLoading(false); });
    }

    // const GetSubCategories = async (rwData) => { setPopupTableData(rwData.SubCategories); openModal(); }

    const columns = [
        { dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
        //{ dataField: 'DayEndRequestId', text: 'DayEnd ReqID', editable: false },
        { dataField: 'AddedOn', text: 'Applied Date', editable: false },
        { dataField: 'AccountName', text: 'Accountant Name', editable: false },
        { dataField: 'Status', text: 'Status', editable: false },
        { dataField: 'Approve_RejectDate', text: 'Approve/Reject Date', editable: false },
        { dataField: 'TotalAmount', text: 'Total Amount', editable: false },
        { dataField: 'actions', text: 'Actions', editable: false,formatter:actionFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } }
    ];

    const popupColumns = [
        { dataField: '#', text: '#', editable: false, formatter: idFormatter, headerStyle: (colum, colIndex) => { return { width: '5%' }; } },
        { dataField: 'PaymentChannels', text: 'Payment Channels', editable: false },
        { dataField: 'CFAmount', text: 'Cash Flow Amount', editable: false },
        { dataField: 'DayEndTotalAmount', text: 'Total Amount', editable: false },
        { dataField: 'Diff', text: 'Difference', editable: false }
    ];

    useEffect(() => {
        btnrpttype.current = '1';
        const today = new Date();
        const date = today.setDate(today.getDate());
        const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
        setDefaultDate(defaultValue);
        GetUsersforDayendreports();
    }, [])

    const GetUsersforDayendreports = async () => {
        var glblArr = [];
        try {
            let url = URL_Start + 'reports/GetUsersforDayendreports/'
            await axios.get(url).then((response) => {
                const data = response.data;
                if (data.Success) {
                    // setUsers(data.Data.map((d) => (<option key={d.Id} value={d.Id}>{d.Value}</option>)))
                    if (data.Data != null) {
                        var itmData = data.Data;
                        itmData.map((option) => { return glblArr.push({ 'value': option.Id, 'label': option.Value, 'disabled': false }); });
                        setUsers(glblArr);
                    }
                    else { setUsers([]); }
                }
            }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }

    const formik = useFormik({
        initialValues: { reportuser: '' },
        onSubmit: values => { BindGrid(fromDate.current.value, toDate.current.value); }
    });


    const handleSearch = async () => {
        if ((typeSelected == [] || typeSelected == null || typeSelected == undefined || typeSelected == "" || typeSelected.length == 0) && btnrpttype.current === '1') {
            SweetAlert.fire('Please select user');
            return false;
        }
        validateDates();
        
    }

    const validateDates = () => {
        const from = new Date(fromDate.current.value);
        const to = new Date(toDate.current.value);
    
        if (isNaN(from) || isNaN(to)) {
          alert('Please enter valid dates.');
          return;
        }
    
        const diffTime = Math.abs(to - from);
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
    
        if (diffDays > 15) {
            SweetAlert.fire('Two date values cannot be greater than 15 days apart.');
            return false;
        } else {
            BindGrid(fromDate.current.value, toDate.current.value);
        }
      };

    const BindGrid = async (fDte, tDte) => {
        const ObjServiceCollection = {
            AccessUserId: localStorage.getItem('LoggedInUser'),
            UserId: typeSelected.length == 0 ? "" : typeSelected,//reportsuser.current.value,
            FromDate: fDte,
            ToDate: tDte,

        };
        setIsLoading(true);
        let url = URL_Start + 'reports/getdayenddatapreview'
        await axios.post(url, ObjServiceCollection).then((response) => {
            const data = response.data;
            if (data.Success) {
                if (data.Data != null) {
                    setTableData(data.Data);
                }
                setIsLoading(false);
            }
            else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); setIsLoading(false); }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } setIsLoading(false); });
    }

    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400") { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }); }
        else if (ErrorCode == "401") { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }); }
        else if (ErrorCode == "403") { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }); }
        else if (ErrorCode == "404") { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }); }
        else if (ErrorCode == "500") { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }); }
        else if (ErrorCode == "503") { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }); }
    }
    const TypeChangeHandler = (options) => { formik.values.reportuser = options.value; setTypeSelected(options.value); }
    return (
        <>
            <Breadcrumb title="DayEnd Difference" parent="Reports" />
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form>
                                    <Form.Row className='justify-content-center'>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label>From Date</Form.Label>
                                                <Form.Control type="date" id="date1" name="date1" ref={fromDate} defaultValue={defaultDate} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                        <Form.Group>
                                                <Form.Label>To Date</Form.Label>
                                                <Form.Control type="date" id="date2" name="date2" ref={toDate} defaultValue={defaultDate} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}></Col>
                                    </Form.Row>
                                </Form>
                                <Form.Row className='justify-content-center'>
                                    <Col md={6} >
                                        <Form.Group>
                                            <div id='selUser'>
                                                <Form.Label>Select User<span className='text-red'>*</span></Form.Label>
                                                {/* <Form.Control as="select" name="reportuser" ref={reportsuser} value={formik.values.reportuser} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                                    <option key="" value="">---Select---</option>
                                                    {users}
                                                </Form.Control>
                                                {formik.touched.reportuser && formik.errors.reportuser ? (<div className='text-required'>{formik.errors.reportuser}</div>) : null} */}
                                                <Select onChange={TypeChangeHandler}
                                                    options={users}
                                                    value={users.filter(function (x) { return x.value === typeSelected; })} />
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} >
                                        <div className="searchButtonSec">
                                            <Button variant='primary' onClick={handleSearch}>Search</Button>
                                        </div>

                                    </Col>

                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                            {
                                    isLoading ?
                                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                        <>
                                            <DataTables  keyField='DayEndRequestId' tableData={tableData} columns={columns} />
                                        </>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {testsModal &&
                    <Modal isOpen={testsModal} toggle={openModal} centered={true} size="lg">
                        <ModalHeader toggle={openModal}>Day End Transfered Amount Details</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={12}>
                                    <Card>
                                        <Card.Body>
                                            <DataTables keyField='DayEndRequestId' tableData={popupTableData} columns={popupColumns} />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                }
            </Container>
        </>
    )
}

export default DayEndDiffReport;